<div class="card section-card mb-3">
  <div class="card-header d-flex align-items-center justify-content-between gap-2">
    <span>{{ 'i18n.domain.theme-showcase.grid.title' | translate }}</span>
    <app-collapse-button [isExpanded]="isExpanded" (toggleExpand)="toggle()"></app-collapse-button>
  </div>

  @if (isExpanded) {
    <div class="card-body">
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.theme-showcase.grid.toolbar.refresh' | translate" prefixIcon="e-icons e-refresh"></e-item>
          <e-item [text]="'i18n.domain.theme-showcase.grid.toolbar.export' | translate" prefixIcon="e-icons e-export"></e-item>
        </e-items>
      </ejs-toolbar>

      <ejs-grid
        class="grid-with-toolbar mt-2"
        width="100%"
        [dataSource]="gridData"
        [allowPaging]="true"
        [allowSorting]="true"
        [pageSettings]="pageSettings">
        <e-columns>
          <e-column field="id" [headerText]="'i18n.domain.theme-showcase.grid.columns.id' | translate" [width]="90"></e-column>
          <e-column field="name" [headerText]="'i18n.shared.fields.name' | translate"></e-column>
          <e-column field="city" [headerText]="'i18n.shared.fields.city' | translate"></e-column>
          <e-column field="isActive" [headerText]="'i18n.shared.fields.active' | translate" [width]="120">
            <ng-template #template let-data>
              @if (data.isActive) {
                <span class="badge text-bg-success">{{ 'i18n.shared.yes' | translate }}</span>
              } @else {
                <span class="badge text-bg-secondary">{{ 'i18n.shared.no' | translate }}</span>
              }
            </ng-template>
          </e-column>
          <e-column field="users" [headerText]="'i18n.domain.theme-showcase.grid.columns.users' | translate" [textAlign]="'Right'" [width]="120"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  }
</div>
